import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateProductoInput,
    CreateProductoRfqInput,
    ProductoRfq,
    UpdateProductoInput,
    UpdateProductoRfqInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class ProductoRfqService {
    private amplifyClient = generateClient();
    constructor() {}

    async listProductoRfqs(): Promise<ProductoRfq[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listProductoRfqs
                })
            ).data.listProductoRfqs.items;
            if (data) return data as ProductoRfq[];
        } catch (error) {
            console.error('Error finding ProductoRfq:', error);
            return null;
        }
    }
    async listProductosRfqPrices(category_id: string): Promise<ProductoRfq[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listProductosRfqPrice,
                    variables: {
                        category_id
                    }
                })
            ).data.listProductosRfqPrice.items;
            if (data) return data as ProductoRfq[];
        } catch (error) {
            console.error('Error finding ProductoRfq:', error);
            return null;
        }
    }

    async createProductoRfq(
        input: CreateProductoRfqInput
    ): Promise<ProductoRfq> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createProductoRfq,
                    variables: {
                        input
                    }
                })
            ).data.createProductoRfq;
            if (date) return date as ProductoRfq;
        } catch (error) {
            console.error('Error creating ProductoRfq:', error);
            return null;
        }
    }
    async updateProductoRfq(
        input: UpdateProductoRfqInput
    ): Promise<ProductoRfq> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateProductoRfq,
                    variables: {
                        input
                    }
                })
            ).data.updateProductoRfq;
            if (date) return date as ProductoRfq;
        } catch (error) {
            console.error('Error creating ProductoRfq:', error);
            return null;
        }
    }
}
